export default __webpack_public_path__ + "static/media/portfolio-130.3b48d5c2.jpg";